import usePostData from '../../../../../hooks/postHook';
import { parcelKeys } from '../../../features_public/parcels/controllers/variables';

export const useGetParcelsImages = () => {
  const [{ data, isLoading, isError, error }, getParcelsImages] = usePostData(
    'office_parcels/images'
  );

  const doGetParcelsImage = ({ parcels }) => {
    const parcel_ids = parcels.map(parcel => parcel[parcelKeys.id]);
    if (parcel_ids == null || parcel_ids.length === 0) return;
    const body = {
      parcel_ids,
      only_thumbs: true,
      limit: 6,
    };
    getParcelsImages(body);
  };

  return {
    data,
    isError,
    error,
    isLoading,
    getParcelsImages: doGetParcelsImage,
  };
};
